module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6a9891055a39d4d618a170cf85891681.png";